import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components6';
import { IconOption } from 'rwl-shared/dist/models/widget';
import { ContentSource } from 'rwl-shared/dist/models/ContentSource';
import { getIcon, getIconColor } from '../../../../utils';
import { When } from 'react-if';
import { ReviewBadge } from '../../../../components/ReviewBadge';

type JobMarkerContentProps = {
    icon: IconOption;
    iconTint: string;
    onClick?: () => void;
    isSelected?: boolean;
    hasReview?: boolean;
    reviewSource?: ContentSource;
};

const MarkerContainer = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !['colors', 'isSelected', 'iconTint'].includes(prop),
})<{
    colors: { fill: string; backDrop: string };
    isSelected?: boolean;
    iconTint?: string;
}>`
    display: inline-flex;
    border: ${({ isSelected, iconTint }) =>
        isSelected ? `2px solid ${iconTint}` : 'none'};
    border-radius: 50%;
    transition: all 0.2s ease;

    :hover {
        background: ${({ colors }) => colors.fill};

        svg {
            background: ${({ colors }) => colors.fill};
            color: ${({ colors }) => colors.backDrop};
        }
    }
`;

const IconContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['colors'].includes(prop),
})<{ colors: { fill: string; backDrop: string } }>`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ colors }) => colors.backDrop};
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    height: 20px;
    width: 20px;
`;

const MarkerWrapper = styled.div`
    position: relative;
`;

const BadgeWrapper = styled.div.withConfig({
    shouldForwardProp: (prop) => !['reviewSource'].includes(prop),
})<{ reviewSource?: ContentSource }>`
    position: absolute;
    top: -8px;
    right: ${({ reviewSource }) =>
        reviewSource === ContentSource.GMB ||
        reviewSource === ContentSource.Facebook
            ? '-18px' // Wide badge with icon + star
            : '-8px'}; // Narrow badge with just star
    z-index: 10;
`;

const JobMarkerContent = ({
    icon,
    iconTint,
    onClick,
    isSelected,
    hasReview,
    reviewSource,
}: JobMarkerContentProps) => (
    <MarkerWrapper>
        <MarkerContainer
            colors={getIconColor(icon, iconTint)}
            isSelected={isSelected}
            iconTint={iconTint}
        >
            <IconContainer
                className="jobMarker"
                colors={getIconColor(icon, iconTint)}
            >
                <FontAwesomeIcon
                    icon={getIcon(icon)}
                    color={getIconColor(icon, iconTint).fill}
                    size="1x"
                    onClick={onClick}
                />
            </IconContainer>
        </MarkerContainer>

        <When condition={hasReview}>
            <BadgeWrapper reviewSource={reviewSource}>
                <ReviewBadge reviewSource={reviewSource} />
            </BadgeWrapper>
        </When>
    </MarkerWrapper>
);

export default JobMarkerContent;
